import ExaminationEventManagement from './ExaminationEventManagement';

export default ExaminationEventManagement;
